import { render, staticRenderFns } from "./iconCancelations.vue?vue&type=template&id=cda753f2&scoped=true"
import script from "./iconCancelations.vue?vue&type=script&lang=js"
export * from "./iconCancelations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda753f2",
  null
  
)

export default component.exports